module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_wisdom_m2.41e37726371f9e7fa483758b3a563203.png";